import { render, staticRenderFns } from "./MuvekkilTableInfo.vue?vue&type=template&id=4fa987dd"
import script from "./MuvekkilTableInfo.vue?vue&type=script&lang=ts"
export * from "./MuvekkilTableInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports